import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { portalApi, apiError } from "@/lib/portalApi";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("Please choose at least 6 characters."); return; }
    if (password !== confirm) { setError("Those passwords don't match."); return; }
    setLoading(true);
    try {
      await portalApi.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/portal/login"), 1800);
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#2A2825] text-[#F4EFE6] grain relative flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <p className="tracking-[0.4em] uppercase text-xs text-[#E8B486] mb-4 text-center">Outpoured Portal</p>
        <h1 className="font-serif-display font-light text-4xl md:text-5xl text-center mb-2">Choose a new password.</h1>
        {done ? (
          <div className="text-center mt-8" data-testid="reset-done">
            <p className="text-[#C9BEB0] font-body mb-6">Your password has been reset. Taking you to sign in…</p>
            <Link to="/portal/login" className="text-[#E8B486] hover:underline text-sm">Go to sign in</Link>
          </div>
        ) : !token ? (
          <p className="text-center text-[#e0a19a] font-body mt-8" data-testid="reset-no-token">This reset link is missing its token. Please request a new one from the sign-in page.</p>
        ) : (
          <form onSubmit={submit} className="space-y-5 mt-8" data-testid="reset-form">
            <div>
              <label className="block text-xs tracking-overline uppercase text-[#C9BEB0] mb-2">New password</label>
              <input data-testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border border-[#5a534b] focus:border-[#E8B486] rounded-md px-4 py-3 text-[#F4EFE6] outline-none transition-colors" />
            </div>
            <div>
              <label className="block text-xs tracking-overline uppercase text-[#C9BEB0] mb-2">Confirm password</label>
              <input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                className="w-full bg-transparent border border-[#5a534b] focus:border-[#E8B486] rounded-md px-4 py-3 text-[#F4EFE6] outline-none transition-colors" />
            </div>
            {error && <p data-testid="reset-error" className="text-[#E8A08a] text-sm font-body">{error}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full rounded-full bg-[#A9724E] hover:bg-[#925C3B] text-[#F4EFE6] py-3.5 text-sm tracking-wide transition-colors duration-500 disabled:opacity-50">
              {loading ? "Resetting…" : "Reset password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
